module.exports = __webpack_public_path__ + "static/media/cactus.94f42264.svg";